




























































































































































































































































































































































































































































































































































































































































// import Vue from 'vue';
import { Component, Prop , Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwDatetimePicker, DateTimePickerConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import  { MswApiService } from '@/shared/msw-api-service';
import { /* ProductServicesAvailable, */ FwProductObjectType, ProductService, /*  ProductFlavour, ProductFlavourService, */ /* CasbAppList, *//*  ProductFlavourRegion, */ AnotherProductObjectModalType, RegisteredProductService } from '../types';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { InfoState /* , SetHelpContentIdPayload */ } from '@/core/core.store';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwForm, SwFormRow } from '@sonicwall/unified-ui-framework/src/shared/sw-form';
import { SwRadio } from '@sonicwall/unified-ui-framework/src/shared/sw-radio';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { SwStatusFlag } from '@libs-uuif/shared/sw-status-flag';
import { SwTable, TableColumnConfig, TableEntryGroup } from '@sonicwall/unified-ui-framework/src/shared/sw-table';

import { /* Getter, */ State } from 'vuex-class';
import { RootStoreState } from '@/store/store';
import { TenantManagementStoreState } from '../msw-tenant-management.store';
// import { productAvailableList } from '../productAvailableServicesList.data';

const cssPrefix = 'tz-nsa-modal';
@Component({
  components: {
    ...UUIFComponents,
    SwIconButton,
    SwIcon,
    SwCheckbox,
    SwDatetimePicker,
    SwSelect,
    SwRadio,
    SwToggle,
    SwForm, SwFormRow,
    SwStatusFlag,
    SwScrollView,
    SwTable,
  },
})
export default class TzNSAProduct extends SwExtendedVue {
  @Prop({ type: Number })
  selectedkey: number;

  @Prop({ type: String })
  modalType: string;

  @Prop({ type: Boolean })
  enableApiCall: boolean;
  @Prop({ default: false })
  editAlowed: boolean;
  @Prop()
  anotherProductModalObject: AnotherProductObjectModalType;
  @Prop()
  showHA: boolean;
  @Prop()
  todayDate: string;

  @Prop()
  from: string;
  @Prop()
  prodChanged: boolean;

  @Prop()
  showOrgId: boolean;
  // @Getter
  // readonly newProductModalObject: Object;
  // @Getter
  // readonly newProductModalObject: Object;
  @State((state: RootStoreState) => state.TenantManagementStoreModule.newProductModalObject)
  readonly newProductModalObject: TenantManagementStoreState['newProductModalObject'] ;
  @State((state: RootStoreState) => state.TenantManagementStoreModule.productAnotherModalObject)
  readonly productAnotherModalObject: TenantManagementStoreState['productAnotherModalObject'] ;

  showSubdomain: string;
  showFriendlyName: string;
  cssPrefix = cssPrefix;
  productOptions: SelectOption[] = [];
  serviceOptions: SelectOption[] = [];
  regionOptions: SelectOption[] = [];
  sslToggleTurnedOff: boolean = false;
  todaysDate:string = '';
  infoIconText: string = '';
  applianceText: string = '';
  showUpperLimit: string = '';
  private registerReturnHandler: (() => void) | null = null;
  childShowUpperLimit:  string = '';
  singlePickerConfig: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.provision.placeholders.pickDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick,
    selectableDatesRange: { startDate: (this.todaysDate.slice(4, 6)).concat('/', this.todaysDate.slice(6), '/', this.todaysDate.slice(0, 4)) },
    hidePreAndNextMonthDates: true,
  };
  singlePickerConfigChild: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.provision.placeholders.pickDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick2,
    selectableDatesRange: { startDate: (this.todaysDate.slice(4, 6)).concat('/', this.todaysDate.slice(6), '/', this.todaysDate.slice(0, 4)) },
    hidePreAndNextMonthDates: true,
  };
  sslPickerConfig: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.provision.placeholders.pickDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClickSsl,
    selectableDatesRange: { startDate: (this.todaysDate.slice(4, 6)).concat('/', this.todaysDate.slice(6), '/', this.todaysDate.slice(0, 4)) },
    hidePreAndNextMonthDates: true,
  };
  productSelectDisabled: boolean = false;
  products:any = {};
  productServicesList: ProductService[] = [];
  firewallOptions: SelectOption[] = [];
  childServiceOptions: SelectOption[] = [];
  regionOprtions: SelectOption[] = [];
  manageOptions: SelectOption[] = [];
  selectedService: any = [];
  showRegion:string = 'NO';
  showZt: boolean = false;
  showExpiry: boolean = false;
  showChildExpiry: boolean = false;
  showUnits: boolean = false;
  showDc: boolean = false;
  invalidSubDomain: boolean = false;
  minCount: any = 0;
  maxCount: any = 0;
  childMinCount: any = 0;
  childMaxCount: any = 0;
  editFriendName = false;
  msspAppliances: any = {};
  firstMsspAppliance:any = {};
  currentServices: string = '';
  fName = '';
  applicationOption: SelectOption[] = [];
  serviceLabel:string = '';
  childServiceLabel: string = '';
  sslServiceLabel: string = '';
  applicableServices: any = [];
  isGen8: boolean = false;
  // firewall: string = '';
  fwProductObject: any = {
    firewall: '',
    productName: '',
    serviceName: '',
    childServiceName: '',
    unitSelected: 'setUpperLimit',
    childUnitSelected: 'setUpperLimit',
    ShowUpperLimit: false,
    ShowChildUpperLimit: false,
    upperLimit: '',
    childUpperLimit: '',
    dateSelected: '',
    expiryType: 'Never',
    childExpiryType: 'Never',
    regionSelected: '',
    childDateSelected: '',
    productId: '',
    applicationName: '',
    friendlyName: '',
    showFriendlyName: 'NO',
    showUnits: false,
    regionName: '',
    showRegion: false,
    showZt: false,
    dataCenter: '',
    manage: 'Cloud',
    dcName: '',
    validationMessage: '',
  };
  registeredProductServices: RegisteredProductService[] = [];
  oldTenantId = '';
  acceptProvision:boolean = false;
  fwRequest: FwProductObjectType = {
    Mode: '',
    validationMessage: '',
    productGroupId: '',
    ProductID: '',
    serialNumber: '',
    serviceId: '',
    nodeCount: '1',
    subDomain: '',
    expirationDate: '',
    regionName: '',
    regionID: '',
    friendlyName: '',
    isZT: 'NO',
    isHA: 'NO',
    Services: [{
      serviceId: '',
      nodeCount: '',
      expirationDate: '',
    }, {
      serviceId: '',
      nodeCount: '',
      expirationDate: '',
    }],
  };
  dateSelected: string = '';
  childDateSelected: string = '';
  ifRegistered:string = '';
  showAgree: boolean = false;
  isDCApplies: boolean = false;
  showMgmtOpt: boolean = false;
  isDisabled: boolean = false;
  serviceTooltip: string = '';
  nsmeId : any = '';
  appShowZt: boolean = false;
  ztValue: boolean = false;
  serviceData: TableEntryGroup[] = [];
  isReadOnly: boolean = false;
  fromScreen: string = '';
  prodId: boolean = false;
  isNsv: boolean = false;
  sslVpnObject: any = {
    serviceId: '',
    showExpiry:false,
    showNodeCount: false,
    sslVpnToggle: false,
    nodeCount: '0',
    totalNodeCount: '0',
    maxNodeCount: '0',
    expiryType: 'Never',
    dateSelected: '',
  };
  @Watch('prodChanged', { immediate: true })
  productChanged() {
    // console.warn('prod', this.prodChanged);
    if (this.prodChanged) {
      this.fwProductObject.firewall = '';
      this.serviceLabel = '';
      this.childServiceLabel = '';
      this.fwProductObject.serviceName = '';
      this.fwProductObject.childServiceName = '';
      this.firewallOptions = [];
      this.showExpiry = false;
      this.showChildExpiry = false;
      this.fwProductObject.ShowUpperLimit = false;
      this.fwProductObject.ShowChildUpperLimit = false;
      this.infoIconText = '';
      this.fwProductObject.showZt = false;
      this.sslVpnObject.sslVpnToggle = false;
      this.sslVpnObject.showExpiry = false;
      this.sslServiceLabel = '';
      this.showError();
      const prodObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      const anProdObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
      this.prodId = anProdObject.productId.toString() !== '-1' && anProdObject.productId.toString() !== '-6' && anProdObject.productId.toString() !== '-7' &&
       anProdObject.productId.toString() !== '-8' && anProdObject.productId.toString() !== '-9' && anProdObject.productId.toString() !== '-10' &&
        anProdObject.productId.toString() !== '-14' && anProdObject.productId.toString() !== '-15' && anProdObject.productId.toString() !== '-16' &&
        anProdObject.productId.toString() !== '-17' && anProdObject.productId.toString() !== '-18' && anProdObject.productId.toString() !== '-19' &&
         anProdObject.productId.toString() !== '-20' &&
         anProdObject.productId.toString() !== '-11' && anProdObject.productId.toString() !== '-12' && anProdObject.productId.toString() !== '-13' ? true : false;
      const data = {
        tenantId: prodObject.tenantId, productId: anProdObject.productId, serialNumber: '', isgetServiceDetails: anProdObject.productId !== '-1'
        && anProdObject.productId.toString() !== '-6' && anProdObject.productId.toString() !== '-9' && anProdObject.productId.toString() !== '-10'
        && anProdObject.productId.toString() !== '-14' && anProdObject.productId.toString() !== '-15' && anProdObject.productId.toString() !== '-16'
        && anProdObject.productId.toString() !== '-17' && anProdObject.productId.toString() !== '-18' && anProdObject.productId.toString() !== '-19'
        && anProdObject.productId.toString() !== '-20'
        && anProdObject.productId.toString() !== '-11' && anProdObject.productId.toString() !== '-12' && anProdObject.productId.toString() !== '-13' ? true : false,
      };
      this.getmsspAppliances(data)
      .then(() => {
        if (this.prodId) {
          this.fwRequest.ProductID = anProdObject.productId;
          this.fwRequest.isZT = this.fwProductObject.showZt ? 'YES' : 'NO';
          this.acceptProvision = true;
          this.populateNsvServices();
        }
      });
      this.isNsv = anProdObject.productId === '-11' || anProdObject.productId === '-12' || anProdObject.productId === '-14'
       || anProdObject.productId === '-17' || anProdObject.productId === '-18' || anProdObject.productId === '-19'
       || anProdObject.productId === '-15' || anProdObject.productId === '-16' || anProdObject.productId === '-20' ?  true : false;
      this.prodChanged = false;
    }
  }
  get checkUpperLimit() {
    if (this.fwProductObject.upperLimit === '') {
      return this.$t('tenantMgmt.provision.validations.upperLimitReq');
    }
    if (Number(this.fwProductObject.upperLimit) < this.minCount || Number(this.fwProductObject.upperLimit) > this.maxCount) {
      return String(this.$t('tenantMgmt.provision.validations.validRange'))
      .concat(this.minCount, String(this.$t('tenantMgmt.provision.validations.and')), this.maxCount);
    }
  }
  get productId() {
    const prodObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    return prodObject.productId.toString() !== '-7' && prodObject.productId.toString() !== '-8';
  }
  get checkChildUpperLimit() {
    if (this.fwProductObject.childUpperLimit === '') {
      return this.$t('tenantMgmt.provision.validations.upperLimitReq');
    }
    if (Number(this.fwProductObject.childUpperLimit) < this.childMinCount || Number(this.fwProductObject.childUpperLimit) > this.childMaxCount) {
      return String(this.$t('tenantMgmt.provision.validations.validRange'))
      .concat(this.childMinCount, String(this.$t('tenantMgmt.provision.validations.and')), this.childMaxCount);
    }
  }
  get epssTooltip(): TooltipDirValues {
    return {
      enabled: this.serviceTooltip !== '',
      placement: 'top',
      content: this.serviceTooltip,
      compact: true,
    };
  }
  get nodeCountTooltip(): TooltipDirValues {
    return {
      enabled: this.sslVpnObject.tooltip !== '',
      placement: 'top',
      content: this.sslVpnObject.tooltip,
      compact: true,
    };
  }
  get fwTooltip(): TooltipDirValues {
    const fwTool = this.firewallOptions.filter((obj:any) => obj.id === this.fwProductObject.firewall)[0] || '';
    return {
      content: fwTool.label,
      enabled: this.fwProductObject.firewall !== '' && this.fwProductObject.firewall !== 'register' && fwTool.label !== '',
      compact: true,
    };
  }
  get getShowErrMsg() {
    const errorFlag = this.newProductModalObject.performFurtherValidation;
    return errorFlag;
  }
  onPencilCick() {
    this.editFriendName = this.modalType !== 'add' ? true : false; this.fName = this.anotherProductModalObject.friendlyName;
  }
  onTickClick() {
    if (this.anotherProductModalObject.friendlyName.trim().length > 0) {
      this.renameProduct(this.anotherProductModalObject.friendlyName);
      this.$store.commit('TenantManagementStoreModule/setNewProductObjectFriendlyName', { friendlyName: this.anotherProductModalObject.friendlyName });
      this.editFriendName = false;
      // this.editFriendlyName(data, false);
    }
  }
  onCrossClick() {
    this.editFriendName = false;
    this.anotherProductModalObject.friendlyName = this.fName;
    // this.editFriendlyName(data, false);
  }
  renameProduct(data: any) {
    this.$store.commit('startLoading');
    const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const renamelist = [{ serialNumber: productObject.serialNumber, newName: data }];
    this.$store.dispatch(
      'MswProductsStoreModule/renameFriendlyName', { prodsRenamelist: renamelist },
    )
    .then((res) => {
      if (res.msgCode === 'MSWAPP:PRODSRENAMESUCCESS') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.$emit('callTmgmt');
      } else if (res.msgCode === 'MSWAPP:PRODSRENAMEFAILURE') {
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.anotherProductModalObject.friendlyName = this.fName;
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: String(this.$t('tenantMgmt.provision.messages.renameFail')) };
        this.$store.commit('enqueueMessage', message);
        this.anotherProductModalObject.friendlyName = this.fName;
      }
      this.$store.commit('stopLoading');
    });
  }
  onFriendlyNameInput() {
    this.fwRequest.friendlyName = this.anotherProductModalObject.friendlyName;
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  onHaToggle() {
    this.fwRequest.isHA = this.anotherProductModalObject?.showHA ? 'YES' : 'NO';
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  showDivider() {
    return (this.prodId || (this.fwProductObject.firewall !== '' && this.fwProductObject.firewall !== 'register')) && this.fwProductObject.childServiceName !== '' &&
    (this.showZt || this.isDCApplies || this.showMgmtOpt);
  }
  onDataCenterSelected() {
    this.showError();
    const reg: any = this.regionOptions.filter(obj => obj.id === this.fwProductObject.dataCenter)[0];
    this.fwRequest.regionName = this.showDc ? reg.value : this.fwProductObject.dataCenter;
    this.fwRequest.regionID = this.fwProductObject.dataCenter;
  }
  onChangeLimit() {
    this.fwProductObject.upperLimit = this.fwProductObject.unitSelected === 'noUpperLimit' ? '99999' : '';
    this.updateNodeCount();
  }
  onChangeChildLimit() {
    this.fwProductObject.childUpperLimit = this.fwProductObject.childUnitSelected === 'noUpperLimit' ? '99999' : '';
    this.updateChildNodeCount();
  }
  updateNodeCount() {
    this.fwRequest.Services[0].nodeCount =  this.fwProductObject.upperLimit;
  }
  updateChildNodeCount() {
    this.fwRequest.Services[1].nodeCount = this.fwProductObject.childUpperLimit;
  }
  onDayClick() {
    this.fwProductObject.expiryType = 'selectExpiry';
    // this.dateSelected = this.fwProductObject.dateSelected !== '' ? this.fwProductObject.dateSelected : this.dateSelected;
    this.fwRequest.Services[0].expirationDate =  this.fwProductObject.dateSelected;
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
    // @ts-ignore
    this.$refs.expiryDate.outsidePopover = true;
    // @ts-ignore
    this.$refs.expiryDate.$emit('input', this.fwProductObject.dateSelected);
  }
  onDayClick2() {
    this.fwProductObject.childExpiryType = 'selectExpiry';
    // this.childDateSelected = this.fwProductObject.childDateSelected !== '' ? this.fwProductObject.childDateSelected : this.childDateSelected;
    this.fwRequest.Services[1].expirationDate = this.fwProductObject.childDateSelected;
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
    // @ts-ignore
    this.$refs.expiryDateChild.outsidePopover = true;
    // @ts-ignore
    this.$refs.expiryDateChild.$emit('input', this.fwProductObject.childDateSelected);
  }
  onDayClickSsl () {
    this.sslVpnObject.expiryType = 'selectExpiry';
    // this.sslVpnObject.dateSelected = this.fwProductObject.childDateSelected !== '' ? this.fwProductObject.childDateSelected : this.childDateSelected;
    // this.fwRequest.Services[2].expirationDate = this.sslVpnObject.dateSelected;
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
    // @ts-ignore
    this.$refs.expiryDateSsl.outsidePopover = true;
    // @ts-ignore
    this.$refs.expiryDateSsl.$emit('input', this.sslVpnObject.dateSelected);
  }
  formatDate(date: any) {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const splitDate = date.split(' ');
    const month = String(monthNames.indexOf(splitDate[0]) + 1);
    // console.warn('formatDate', (month)
    // .concat('/', splitDate[1], '/', splitDate[2]));
    return month.length === 1 ? '0'.concat(month, '/', splitDate[1], '/', splitDate[2]) :
    month.concat('/', splitDate[1], '/', splitDate[2]);
  }
  ztChange() {
    this.fwRequest.isZT = this.fwProductObject.showZt ? 'YES' : 'NO';
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  sslVpnChange() {
    this.fwRequest.Services.push({
      serviceId: this.sslVpnObject.serviceId,
      nodeCount: this.sslVpnObject.nodeCount,
      expirationDate: this.sslVpnObject.expiryType === 'selectExpiry' ? this.sslVpnObject.dateSelected : 'Never',
    });
  }
  onChangeExpiry() {
    this.fwProductObject.dateSelected = this.fwProductObject.expiryType === 'Never' ? '' : this.dateSelected;
    this.fwRequest.Services[0].expirationDate = this.fwProductObject.dateSelected === '' && this.fwProductObject.expiryType === 'Never' ? 'Never' : this.fwProductObject.dateSelected;
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  onChangeChildExpiry() {
    this.fwProductObject.childDateSelected = this.fwProductObject.childExpiryType === 'Never' ? '' : this.childDateSelected;
    this.fwRequest.Services[1].expirationDate = this.fwProductObject.childDateSelected === '' && this.fwProductObject.childExpiryType === 'Never' ? 'Never' : this.fwProductObject.childDateSelected;
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  onChangeSslExpiry() {
    this.sslVpnObject.dateSelected = this.sslVpnObject.expiryType === 'Never' ? '' : this.sslVpnObject.dateSelected;
    // this.fwRequest.Services[2].expirationDate = this.sslVpnObject.dateSelected === '' && this.sslVpnObject.expiryType === 'Never' ? 'Never' : this.sslVpnObject.dateSelected;
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  showError() {
    this.$store.commit('TenantManagementStoreModule/setNewProductObjectFurtherValidation', { performFurtherValidation: false });
  }
  onClickAccept() {
    // console.warn('why empty', this.fwProductObject);
    this.fwRequest.Services[0].expirationDate = this.fwProductObject.expiryType === 'Never' ? 'Never' : this.fwProductObject.dateSelected;
    // console.warn('why1', this.fwRequest.Services[0].expirationDate, this.fwProductObject.childExpiryType, this.fwProductObject.childDateSelected, this.fwProductObject.dateSelected);
    this.fwRequest.Services[1].expirationDate = (this.isGen8 || this.childServiceLabel === 'Data retention add-on') && !this.showChildExpiry ? this.fwRequest.Services[0].expirationDate :
     this.fwProductObject.childExpiryType === 'Never' ? 'Never' : this.fwProductObject.childDateSelected;
    // console.warn('why2', this.fwRequest.Services[1]['expirationDate']);
    if (this.childServiceLabel !== '') {
      this.$store.commit('TenantManagementStoreModule/setTzProvision', { tzProvision: this.acceptProvision });
    }
    // console.warn('tzmodal', this.acceptProvision);
    this.$emit('onAgree', this.fwRequest, this.isDCApplies, this.showExpiry, this.showChildExpiry, this.sslVpnObject, this.fwProductObject.unitSelected, this.fwProductObject.childUnitSelected);
  }
  onRegionSelected() {
    const regionName = this.regionOptions.filter((ele: SelectOption) =>  ele.id === this.fwProductObject.regionSelected);
    this.fwProductObject.regionName = regionName[0] ? regionName[0].label.toString() : '';
    this.showError();
    // this.updateProductState();
  }

  onFirewallSelected() {
    if (this.fwProductObject.firewall === 'register') {
      // console.warn(window.location.origin);
      const isCustView = sessionStorage.getItem('isCustView') === 'YES';
      const registerUrl = `${window.location.origin}/workspace/m/feature/register-products${isCustView ? '?isCustView=YES' : ''}`;
      window.open(registerUrl);
      this.registerReturnHandler = () => {
        if (!document.hidden) {
          document.removeEventListener('visibilitychange', this.registerReturnHandler!);
          this.registerReturnHandler = null;
          const prodObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
          const anProdObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
          const data = {
            tenantId: prodObject.tenantId,
            productId: anProdObject.productId,
            serialNumber: '',
            isgetServiceDetails: false,
          };
          this.fwProductObject.firewall = '';
          this.getmsspAppliances(data);
        }
      };
      document.addEventListener('visibilitychange', this.registerReturnHandler);
      // this.$router.push({ path: '/m/feature/register-products?redirectTo=productTab' });
    } else {
      const sNum = (this.firstMsspAppliance.serialList.filter((obj:any) => obj.serialNumber ? (obj.serialNumber).toString()
      .toUpperCase() === (this.fwProductObject.firewall).toString()
      .toUpperCase() : (obj.productId).toString()
      .toUpperCase() === (this.fwProductObject.firewall).toString()
      .toUpperCase()))[0];
      this.fwRequest.ProductID = sNum.productId;
      this.fwRequest.serialNumber = sNum.serialNumber;
      this.fwRequest.isZT = this.fwProductObject.showZt ? 'YES' : 'NO';
      this.fwRequest.friendlyName = sNum.friendlyName;
      this.isGen8 = sNum.productChoiceId === '-6' || sNum.productChoiceId === '-10';
      const prodObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      // const anProdObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
      const data = {
        tenantId: prodObject.tenantId, productId: sNum?.productChoiceId || sNum?.productId, serialNumber: sNum.serialNumber, isgetServiceDetails: true,
      };
      this.fwProductObject.serviceName = '';
      this.fwProductObject.childServiceName = '';
      this.acceptProvision = false;
      // this.onClickAccept();
      this.showError();
      if (this.modalType === 'add') {
        this.getmsspAppliances(data)
        .then((res) => {
          if (res) {
            this.populateService();
          }
        });
      } else {
        this.populateService();
      }
      // const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      this.showError();
      // console.warn('fire', this.fwProductObject.firewall);
    }
  }
  populateService() {
    const fw = (this.firstMsspAppliance.serialList.filter((obj:any) => obj.serialNumber ? obj.serialNumber.toString()
    .toUpperCase() === (this.fwProductObject.firewall.toString()
      .toUpperCase()
    ) : obj.productId.toString()
    .toUpperCase() === (this.fwProductObject.firewall.toString()
      .toUpperCase())))[0];
    this.showAgree = fw.ShowLicAgr === 'YES' ? true : false;
    this.fwProductObject.showApplicationOption = false;
    this.acceptProvision = !this.showAgree ? true : false;
    this.manageOptions = [];
    this.msspAppliances.FirewallManagementoptiondetails?.firewallmgnoptions?.map((mnge: any) => {
      this.manageOptions.push({
        id: mnge.optionname,
        label: mnge.optionname,
        value: mnge.optionname,
      });
      this.fwProductObject.manage = mnge.currentOption === 1 ? mnge.optionname : this.fwProductObject.manage;
    });
    if (this.msspAppliances.hasOwnProperty('provisionserviceOptions')) {
      const obj = this.msspAppliances.provisionserviceOptions[0] || null;
      if (obj && obj !== null) {
        const obj = this.msspAppliances.provisionserviceOptions[0] || {};
        if (obj?.productId === (fw.productId) || fw.productId) {
          this.serviceOptions = [];
          this.serviceLabel = obj.serviceNameDisplay;
          obj.serviceOptions.map((ele:any) => {
            // console.warn('ele', ele.serviceId, ele.serviceName);
            this.serviceOptions.push({
              id: ele.serviceId.toString(),
              label: ele.serviceName,
              value: ele.serviceName,
            });
            if (ele.isselected === 'YES') {
              this.fwProductObject.serviceName = ele.isselected === 'YES' ? ele.serviceId.toString() : this.fwProductObject.serviceName;
              this.showExpiry = ele.showExpDate === 'YES' ? true :false;
              this.fwProductObject.expiryType = ele.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
              this.fwProductObject.dateSelected = ele.expDate === 'Never' ||  ele.isExpiryNever === 'YES' ? '' : ele.expDate;
              this.infoIconText = ele?.infoIconText ? ele?.infoIconText : '';
            }
          });
        }
        const sslVpnObj = this.msspAppliances?.provisionserviceOptions[1] || null;
        if (sslVpnObj !== null) {
          this.sslServiceLabel = sslVpnObj.serviceNameDisplay;
          // console.warn(this.msspAppliances.provisionserviceOptions[1]['serviceOptions']);
          const sslVpnService =  sslVpnObj.serviceOptions[0] ;
          this.sslVpnObject = {
            serviceId: sslVpnService.serviceId,
            showExpiry: sslVpnService.showExpDate === 'YES' ? true :false,
            showNodeCount: sslVpnService.showNodeCount === 'YES' ? true :false,
            sslVpnToggle: sslVpnService.isselected === 'YES' ? true : false,
            nodeCount: sslVpnService.nodeCount || '0',
            totalNodeCount: sslVpnService.defaultNodecount || '0',
            maxNodeCount: String(sslVpnService.maxNodeCount),
            expiryType: sslVpnService.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry',
            dateSelected: sslVpnService.expDate === 'Never' ||  sslVpnService.isExpiryNever === 'YES' ? '' : sslVpnService.expDate,
            tooltip: sslVpnService.tooltip,
          };
          this.sslVpnObject.sslVpnToggle ? this.sslToggleTurnedOff = false : this.sslToggleTurnedOff = true;
        }
      }
    }
    console.warn('fw', fw);
    fw.currentServiceList.map((obj:any) => {
      // console.warn('current', obj);
      this.currentServices = obj.serviceGroupDisplayName;
      // if (obj.hasOwnProperty('applicableServices')) {
      //   console.warn('app', obj.applicableServices);
      //   this.applicableServices = obj.applicableServices;
      //   obj.applicableServices.map((ele:any) => {
      //     console.warn(ele.serviceId, 'sars');
      //     this.serviceOptions.map((item:any) => {
      //       console.warn(item.id, ele.serviceId, ele.serviceName, this.serviceLabel, this.childServiceLabel, 'sar');
      //       if (ele.hasOwnProperty('serviceId') && item.id === (ele.serviceId.toString())) {
      //         this.fwProductObject.serviceName = item.id;
      //         this.showExpiry = true;
      //         this.fwProductObject.expiryType = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? 'Never' : 'selectExpiry';
      //         this.fwProductObject.dateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' : this.formatDate(ele.expDate.trim());
      //         this.dateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' :this.formatDate(ele.expDate.trim());
      //       } else if (!ele.hasOwnProperty('serviceId') && ele.serviceName === this.serviceLabel) {
      //         this.fwProductObject.serviceName = '-1';
      //         this.showExpiry = item.showExpDate;
      //       }
      //     });
      //   });
      this.onServiceSelected();
      // }
      if (this.msspAppliances.hasOwnProperty('arrDcList') && !this.msspAppliances.hasOwnProperty('dcName')) {
        this.regionOptions = [];
        this.msspAppliances.arrDcList.map((list: any) => {
          this.regionOptions.push({
            id: list.dcId.toString(),
            label: list.description,
            value: list.name,
          });
        });
        if (this.regionOptions.length >= 1) {
          this.fwProductObject.dataCenter = this.regionOptions[0].id;
          this.fwRequest.regionID = this.regionOptions[0].id;
          this.fwRequest.regionName = this.regionOprtions[0].label.toString();
        }
      }
    });
    const appSrvices: any = [];
    this.applicableServices.map((obj: any) => {
      const serviceObj: any = {
        _key: obj.serviceName,
        serviceName: obj.serviceName,
        expiryDate: obj.expDate,
      };
      appSrvices.push(serviceObj);
    });
    this.serviceData = appSrvices;
    if (this.modalType !== 'add') {
      setTimeout(() => {
        this.$store.commit('stopLoading');
      }, 3000); // tslint:disable-line
    }
    this.onClickAccept();
  }
  populateNsvServices() {
    this.fwProductObject.showApplicationOption = false;
    // this.showAgree = true;
    // this.acceptProvision = !this.showAgree ? true : false;
    this.manageOptions = [];
    this.msspAppliances.FirewallManagementoptiondetails?.firewallmgnoptions?.map((mnge: any) => {
      this.manageOptions.push({
        id: mnge.optionname,
        label: mnge.optionname,
        value: mnge.optionname,
      });
      this.fwProductObject.manage = mnge.currentOption === 1 ? mnge.optionname : this.fwProductObject.manage;
    });
    if (this.msspAppliances.hasOwnProperty('provisionserviceOptions')) {
      const obj = this.msspAppliances.provisionserviceOptions[0] || {};
      if (this.prodId) {
        this.serviceOptions = [];
        this.serviceLabel = obj.serviceNameDisplay;
        obj.serviceOptions.map((ele:any) => {
          // console.warn('ele', ele.serviceId, ele.serviceName);
          this.serviceOptions.push({
            id: ele.serviceId.toString(),
            label: ele.serviceName,
            value: ele.serviceName,
          });
          if (ele.isselected === 'YES') {
            this.fwProductObject.serviceName = ele.isselected === 'YES' ? ele.serviceId.toString() : this.fwProductObject.serviceName;
            this.showExpiry = ele.showExpDate === 'YES' ? true :false;
            this.fwProductObject.expiryType = ele.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
            this.fwProductObject.dateSelected = ele.expDate === 'Never' ||  ele.isExpiryNever === 'YES' ? '' : ele.expDate;
          }
        });
      }
      const sslVpnObj = this.msspAppliances?.provisionserviceOptions[1] || null;
      if (sslVpnObj !== null) {
        this.sslServiceLabel = sslVpnObj.serviceNameDisplay;
        // console.warn(this.msspAppliances.provisionserviceOptions[1]['serviceOptions']);
        const sslVpnService =  sslVpnObj.serviceOptions[0] ;
        this.sslVpnObject = {
          serviceId: sslVpnService.serviceId,
          showExpiry: sslVpnService.showExpDate === 'YES' ? true :false,
          showNodeCount: sslVpnService.showNodeCount === 'YES' ? true :false,
          sslVpnToggle: sslVpnService.isselected === 'YES' ? true : false,
          nodeCount: sslVpnService.nodeCount || '0',
          totalNodeCount: sslVpnService.defaultNodecount || '0',
          maxNodeCount: String(sslVpnService.maxNodeCount),
          expiryType: sslVpnService.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry',
          dateSelected: sslVpnService.expDate === 'Never' ||  sslVpnService.isExpiryNever === 'YES' ? '' : sslVpnService.expDate,
          tooltip: sslVpnService.tooltip,
        };
      }
    }
    this.onServiceSelected();
    if (this.msspAppliances.hasOwnProperty('arrDcList') && !this.msspAppliances.hasOwnProperty('dcName')) {
      this.regionOptions = [];
      this.msspAppliances.arrDcList.map((list: any) => {
        this.regionOptions.push({
          id: list.dcId.toString(),
          label: list.description,
          value: list.name,
        });
      });
    }
    const appSrvices: any = [];
    this.applicableServices.map((obj: any) => {
      const serviceObj: any = {
        _key: obj.serviceName,
        serviceName: obj.serviceName,
        expiryDate: obj.expDate,
      };
      appSrvices.push(serviceObj);
    });
    this.serviceData = appSrvices;
    if (this.modalType !== 'add') {
      setTimeout(() => {
        this.$store.commit('stopLoading');
      }, 3000); // tslint:disable-line
    }
    this.onClickAccept();
  }
  resetValues() {
    this.fwProductObject.productName = '';
    this.fwProductObject.serviceName = '';
  }

  get getProductNewModalObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
  }

  get getDisabledStateForProduct() {
    const productDetailsFromStore = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const msspName = productDetailsFromStore.msspName;
    const tenantName = productDetailsFromStore.tenantName;
    if ((msspName !== '' &&  tenantName !== '')) {
      // this.loadAnotherProductApi();
    }
    return !(msspName !== '' &&  tenantName !== '');
  }
  get getNodeCountErr() {
    let res: boolean = false;
    if (this.sslVpnObject.sslVpnToggle
    && this.getShowErrMsg && Number(this.sslVpnObject.nodeCount) <= 0) {
      res = true;
    } else if (this.sslVpnObject.sslVpnToggle
    && this.getShowErrMsg
    && Number(this.sslVpnObject.nodeCount) + Number(this.sslVpnObject.totalNodeCount) > Number(this.sslVpnObject.maxNodeCount)) {
      res = true;
    } else {
      res = false;
    }
    return res;
  }
  get checkForDate() {
    let res: boolean = false;
    if (this.getShowErrMsg
    && this.sslVpnObject.expiryType === 'selectExpiry'
    && this.sslVpnObject.dateSelected === '') {
      res = true;
    } else {
      res = false;
    }
    return res;
  }
  onChangeSSL() {
    if (!this.sslVpnObject.sslVpnToggle && this.modalType === 'add') {
      this.sslVpnObject.expiryType = 'Never';
      this.sslVpnObject.dateSelected = '';
      this.sslVpnObject.nodeCount = '0';
    } else if (!this.sslVpnObject.sslVpnToggle
    && this.modalType === 'edit'
    && !this.sslToggleTurnedOff) {
      const req: any = {
        ProductID: this.productAnotherModalObject.productId,
        serviceId: '',
        nodeCount: this.productAnotherModalObject.upperLimit,
        expirationDate: this.productAnotherModalObject.dateSelected === '' ? 'Never' : this.productAnotherModalObject.dateSelected,
        regionName: '',
        regionID: '',
        serialNumber: this.fwProductObject.firewall,
        friendlyName: this.productAnotherModalObject.friendlyName,
        isHA: this.productAnotherModalObject.showHA ? 'YES' : 'NO',
        expireService: 'YES',
      };
      const sslVpnObj = this.msspAppliances?.provisionserviceOptions[1] || null;
      if (sslVpnObj !== null) {
        const sslVpnService =  sslVpnObj.serviceOptions[0] ;
        req.serviceId = sslVpnService.serviceId.toString();
      }
      this.$store.commit('startLoading');
      MswApiService.tenant.editProductProvision(req)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.sslVpnObject.expiryType = 'Never';
          this.sslVpnObject.dateSelected = '';
          this.sslVpnObject.nodeCount = '0';
          this.sslToggleTurnedOff = true;
          this.$emit('sslTurnedOf');
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          this.sslVpnObject.sslVpnToggle = true;
        }
      });
    }
  }
  onServiceSelected() {
    // let disAbled: boolean = false;
    // let tooltipVal: string = '';
    const epssId = this.msspAppliances?.serviceIDsToValidate?.split(',').filter((s: string) => s.trim() !== '');
    this.fwProductObject.validationMessage = '';
    this.msspAppliances.provisionserviceOptions?.map((serv: any) => {
      // const ifServiceNOtChanged = ((fw.currentServiceList[0].applicableServices[0].serviceName.toLowerCase()).includes(this.serviceLabel.toLowerCase())) &&
      //   (fw.currentServiceList[0].applicableServices[1].serviceName.toLowerCase()).includes(this.serviceLabel.toLowerCase());
      // const noChange = serv.serviceOptions.filter((obj:any) => obj.serviceId === -1)[0];
      this.$emit('lic');
      serv.serviceOptions?.map((obj:any) => {
        if (obj.serviceId === Number(this.fwProductObject.serviceName)) {
          this.selectedService = obj ;
          this.fwProductObject.validationMessage = epssId?.some((item: any) => Number(item.trim()) === obj.serviceId) ? (this.msspAppliances.ValidationMessage ?? '') : '';
          this.showExpiry = obj.showExpDate === 'YES' ? true : false;
          this.fwProductObject.expiryType = obj.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
          this.fwProductObject.dateSelected = obj.expDate === 'Never' ||  obj.isExpiryNever === 'YES' ? '' : obj.expDate;
          this.fwProductObject.ShowUpperLimit = obj.ShowUpperLimit === 'NOCAP' || obj.ShowUpperLimit === 'YES';
          this.showUpperLimit = obj.ShowUpperLimit;
          this.fwProductObject.unitSelected = obj.ShowUpperLimit === 'NOCAP' || obj?.nodeCount === '99999' || obj?.nodeCount === '99998' ||
          obj?.nodeCount === 'No upper limit' ? 'noUpperLimit' : 'setUpperLimit';
          this.infoIconText = obj?.infoIconText ? obj?.infoIconText : '';
          this.fwProductObject.upperLimit = this.fwProductObject.unitSelected === 'noUpperLimit' ? '99999' :
           obj.nodeCount === undefined ? '' : obj.nodeCount;
          this.minCount = obj?.minNodeCount || 0;
          this.maxCount = obj?.maxNodeCount || 0;
          this.isReadOnly = false;
          this.childServiceOptions = [];
          this.fwProductObject.childServiceName = '';
          this.showZt = obj.showZeroTouch === 'YES' ? true : false;
          this.ztValue = obj.ztValue === 1 ? true : false;
          this.fwProductObject.showZt = obj.isZTApplicable === 'YES' ? this.ztValue : false;
          this.isDCApplies = obj.isDCApplies === 'YES' ? true : false;
          this.showMgmtOpt = obj.showMgmtOpt === 'YES' ? true : false;
          this.$emit('dc');
          obj.childOptions?.map((ele: any) => {
            this.childServiceLabel = ele.childserviceNameDisp;
            // console.warn('childele', ele);
            if (this.childServiceLabel !== '') {
              ele.childServiceOptions.map((childEle: any) => {
                this.childServiceOptions.push({
                  id: childEle.serviceId.toString(),
                  label: childEle.serviceName,
                  value: childEle.serviceName,
                });
                if (childEle.isselected === 'YES') {
                  this.fwProductObject.childServiceName = childEle.isselected === 'YES' ? childEle.serviceId.toString() : this.fwProductObject.childServiceName;
                  this.showZt = childEle.showZeroTouch === 'YES' ? true : false;
                  this.ztValue = childEle.ztValue === 1 ? true : false;
                  this.showChildExpiry = childEle.showExpDate === 'YES' ? true : false;
                  this.fwProductObject.childExpiryType =  childEle.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
                  this.fwProductObject.childDateSelected = childEle.expDate === 'Never' || childEle.isExpiryNever === 'YES' ? '' : childEle.expDate;
                  this.fwProductObject.ShowChildUpperLimit = childEle.ShowUpperLimit === 'NOCAP' || childEle.ShowUpperLimit === 'YES';
                  this.childShowUpperLimit = childEle.ShowUpperLimit;
                  this.fwProductObject.childUnitSelected = childEle.ShowUpperLimit === 'NOCAP' || childEle?.nodeCount === '99999' || childEle?.nodeCount === '99998' ||
                  childEle?.nodeCount === 'No upper limit' ? 'noUpperLimit' : 'setUpperLimit';
                  this.fwProductObject.childUpperLimit = this.fwProductObject.childUnitSelected === 'noUpperLimit' ? '99999' :
                  childEle?.nodeCount === undefined ? '' : childEle?.nodeCount;
                  this.childMinCount = childEle?.minNodeCount || 0;
                  this.childMaxCount = childEle?.maxNodeCount || 0;
                  this.isDisabled = childEle.isDisabled === 'YES' ? true : false;
                  this.serviceTooltip = childEle.tooltip !== '' ? childEle.tooltip : '';
                  this.isReadOnly = childEle.isReadOnly === 'YES' ? true : false;
                }
              });
            }
          });
        } /* else if (ifServiceNOtChanged) {
          this.selectedService = noChange ;
          this.showExpiry = noChange.showExpDate === 'YES' ? true : false;
          this.childServiceOptions = [];
          noChange.childOptions.map((ele: any) => {
            this.childServiceLabel = ele.childserviceNameDisp;
            console.warn('childele', ele);
            ele.childServiceOptions.map((childEle: any) => {
              if (childEle.serviceId === 46465) {
                disAbled = childEle.isDisabled === 'YES' ? true : false;
                tooltipVal = childEle.tooltip !== '' ? childEle.tooltip : '';
              }'No upper limit
              this.childServiceOptions.push({
                id: childEle.serviceId.toString(),
                label: childEle.serviceName,
                value: childEle.serviceName,
              });
            });
          });
        } */
      });
    });
    // console.warn('fw', fw);
    // fw.currentServiceList.map((obj:any) => {
      // if (obj.hasOwnProperty('applicableServices')) {
      //   obj.applicableServices.map((ele:any) => {
      //     this.childServiceOptions.map((item:any) => {
      //       console.warn('hilserv', ele.serviceId, item.id);
      //       if ((ele.serviceName.toLowerCase()).includes(this.childServiceLabel.toLowerCase()) || ele.hasOwnProperty('serviceId') && (item.id ===  ele.serviceId.toString())) {
      //         console.warn('rec', item.id, this.fwProductObject.childExpiryType);
      //         this.fwProductObject.childServiceName = (ele.serviceName.toLowerCase()).includes(this.childServiceLabel.toLowerCase()) || !val ? '' : item.id;
      //         this.appShowZt = ele.showZeroTouch === 'YES' ? true : false;
      //         this.ztValue = ele.ztValue === 1 ? true : false;
      //         if (val || (ele.serviceName.toLowerCase()).includes(this.childServiceLabel.toLowerCase())) {
      //           this.showChildExpiry = this.fwProductObject.childServiceName !== '' ? true : false;
      //           this.fwProductObject.childExpiryType = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? 'Never' : 'selectExpiry';
      //           console.warn('expchild', this.fwProductObject.ChildExpiryType, ele.expDate);
      //           this.fwProductObject.childDateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' : this.formatDate(ele.expDate.trim());
      //           this.childDateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' : this.formatDate(ele.expDate.trim());
      //         } else {
      //           this.showChildExpiry = false;
      //           // this.fwProductObject.childExpiryType = 'Never';
      //           // this.fwProductObject.childDateSelected =  '';
      //           // this.appShowZt = false;
      //           // this.ztValue = false;
      //         }
      //       }
      //     });
      //   });
      // }
    // });
    // console.warn('chid', this.fwProductObject.serviceName);
    // if (this.fwProductObject.serviceName === '7223') {
    //   this.isDisabled = true;
    //   this.fwProductObject.childServiceName = '46465';
    //   this.serviceTooltip = tooltipVal;
    // } else if (disAbled && this.fwProductObject.childServiceName !== '') {
    //   this.isDisabled = true;
    //   this.serviceTooltip = tooltipVal;
    // } else {
    //   this.isDisabled = false;
    //   this.serviceTooltip = '';
    // }
    this.fwRequest.validationMessage = this.fwProductObject.validationMessage;
    this.fwRequest.Services[0].serviceId = this.fwProductObject.serviceName;
    this.fwRequest.Services[0].expirationDate = (this.fwProductObject.dateSelected === '' && this.fwProductObject.expiryType === 'Never') || !this.showExpiry ? 'Never' : (this.fwProductObject.dateSelected);
    this.fwRequest.Services[0].nodeCount = this.fwProductObject.ShowUpperLimit ? this.fwProductObject.upperLimit : '1';
    if (this.childServiceLabel !== '') {
      this.onChildServiceSelected();
    }
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  onChildServiceSelected() {
    if (this.fwProductObject.serviceName !== '') {
      this.selectedService.childOptions.map((obj:any) => {
        obj.childServiceOptions.map((ele:any) => {
          // console.warn('objChild', ele.serviceId , this.fwProductObject.childServiceName);
          if (ele.serviceId === Number(this.fwProductObject.childServiceName)) {
            this.showChildExpiry = ele.showExpDate === 'YES' ? true : false;
            this.isDisabled = ele.isDisabled === 'YES' ? true : false;
            this.serviceTooltip = ele.tooltip !== '' ? ele.tooltip : '';
            this.showZt = ele.showZeroTouch === 'YES' ? true : false;
            this.ztValue = ele.ztValue === 1 ? true : false;
            this.fwProductObject.childExpiryType =  ele.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
            this.fwProductObject.childDateSelected = ele.expDate === 'Never' || ele.isExpiryNever === 'YES' ? '' : ele.expDate;
            this.fwProductObject.ShowChildUpperLimit = ele.ShowUpperLimit === 'YES' || ele.ShowUpperLimit === 'NOCAP';
            this.childShowUpperLimit = ele.ShowUpperLimit;
            this.fwProductObject.childUnitSelected = ele.ShowUpperLimit === 'NOCAP' || ele?.nodeCount === '99999' || ele?.nodeCount === '99998' ||
                 ele?.nodeCount === 'No upper limit' ? 'noUpperLimit' : 'setUpperLimit';
            this.fwProductObject.childUpperLimit = this.fwProductObject.childUnitSelected === 'noUpperLimit' ? '99999' :
                ele?.nodeCount === undefined ? '' : ele?.nodeCount;
            this.childMinCount = ele?.minNodeCount || 0;
            this.childMaxCount = ele?.maxNodeCount || 0;
            this.fwProductObject.showZt = ele.isZTApplicable === 'YES' ? this.ztValue : false;
            this.isDCApplies = ele.isDCApplies === 'YES' ? true : false;
            this.showMgmtOpt = ele.showMgmtOpt === 'YES' ? true : false;
            this.isReadOnly = ele.isReadOnly === 'YES' ? true : false;
            this.ztChange();
          }
        });
      });
    }
    this.fwRequest.Services[1].expirationDate = this.isGen8 && !this.showChildExpiry ? this.fwProductObject.dateSelected :
     (this.fwProductObject.childDateSelected === '' && this.fwProductObject.childExpiryType === 'Never') || !this.showChildExpiry ? 'Never' : this.fwProductObject.childDateSelected;
    this.fwRequest.Services[1].serviceId = this.isDisabled && !this.isReadOnly ? '' : this.fwProductObject.childServiceName;
    this.fwRequest.Services[1].nodeCount = this.fwProductObject.ShowChildUpperLimit ? this.fwProductObject.childUpperLimit : '1';
    // console.warn(this.fwRequest, 'request');
    this.showError();
    if (!this.showAgree) {
      this.onClickAccept();
    }
    this.nsmeId = document.querySelectorAll('[id$="-46465"]');
  }
  get applicableColumnConfig(): TableColumnConfig[] {
    return [{
      key: 'serviceName',
      dataKey: 'serviceName',
      title: this.currentServices,
      tooltip: { content: this.currentServices, compact: true },
      width: 230,
    }, {
      key: 'expiryDate',
      dataKey: 'expiryDate',
      title: String(this.$t('tenantMgmt.provision.expirationDate')),
      width: 120,
    }];
  }
  refresh() {
    this.fwProductObject.firewall = '';
    this.serviceLabel = '';
    this.childServiceLabel = '';
    this.fwProductObject.serviceName = '';
    this.fwProductObject.childServiceName = '';
    this.showExpiry = false;
    this.showChildExpiry = false;
    this.fwProductObject.ShowUpperLimit = false;
    this.fwProductObject.ShowChildUpperLimit = false;
    this.acceptProvision = false;
    const prodObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const anProdObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    const data = {
      tenantId: prodObject.tenantId, productId: anProdObject.productId, serialNumber: '', isgetServiceDetails: false,
    };
    this.getmsspAppliances(data);
    this.onClickAccept();
    this.showError();
  }
  getmsspAppliances(data: any) {
    return new Promise((res) => {
      this.$store.commit('startLoading');
      MswApiService.tenant.getMsspAppliances(data)
      .then((resp: any) => {
        this.msspAppliances = resp.content;
        this.showDc = this.msspAppliances.showDC === 'YES' ? true : false;
        this.fwProductObject.dcName = this.msspAppliances.dcName ? this.msspAppliances.dcName : '';
        this.fwRequest.regionName = this.fwProductObject.dcName;
        // console.warn('msspAppliances', this.msspAppliances);
        if (this.modalType !== 'add') {
          this.firstMsspAppliance = this.msspAppliances;
        }
        this.applianceText = this.msspAppliances?.applianceText || '';
        if (this.msspAppliances.hasOwnProperty('serialList') && this.fwProductObject.firewall === '') {
          this.firewallOptions = [];
          this.firstMsspAppliance = this.msspAppliances;
          if (this.msspAppliances.showRegisterNewProduct === 'YES') {
            this.firewallOptions.push({
              id: 'register',
              label: this.msspAppliances.showRegisterNewProductLabel,
              value: 'register',
            });
          }
          this.msspAppliances.serialList.map((obj:any) => {
            // console.warn('obj', obj);
            this.firewallOptions.push({
              id: obj.serialNumber ? obj.serialNumber : obj.productId.toString(),
              label: obj.serialNumber ? obj.friendlyName.concat(' - ' , obj.serialNumber) : obj.friendlyName,
              value: obj.productId,
            });
          });
        } else {
          if (this.msspAppliances.showRegisterNewProduct === 'YES' && this.firewallOptions.length <= 1) {
            this.firewallOptions = [];
            this.firewallOptions.push({
              id: 'register',
              label: this.msspAppliances.showRegisterNewProductLabel,
              value: 'register',
            });
          }
        }
        // if (this.msspAppliances.showDC === 'YES') {
        //   this.regionOptions = [];
        //   this.msspAppliances.dcRegion.map((obj: any) => {
        //     this.regionOptions.push({
        //       id: obj.dcId.toString(),
        //       label: obj.name,
        //       value: obj.dcId,
        //     });
        //   });
        // }
        if (this.fwRequest.ProductID !== '-11' && this.fwRequest.ProductID !== '-12') {
          const fw = (this.msspAppliances.serialList.filter((obj:any) => obj.serialNumber.toString()
        .toUpperCase() === (this.fwProductObject.firewall.toString()
          .toUpperCase()
        ) || obj.productId.toString()
        .toUpperCase() === (this.fwProductObject.firewall.toString()
          .toUpperCase()
        )))[0];
          fw.currentServiceList.map((obj:any) => {
            this.currentServices = obj.serviceGroupDisplayName;
            if (obj.hasOwnProperty('applicableServices')) {
              // console.warn('app', obj.applicableServices);
              this.applicableServices = obj.applicableServices;
            }
          });
        }
        this.$store.commit('TenantManagementStoreModule/setRegisterd', { registered: false });
        if (this.modalType === 'add') {
          this.$store.commit('stopLoading');
        }
        res(true);
      })
      .catch(() => {
        res(true);
        this.$store.commit('stopLoading');
      });
    });
  }
  // @Watch('ifRegistered')
  registered() {
    const prodObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const anProdObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    const data = {
      tenantId: prodObject.tenantId, productId: anProdObject.productId, serialNumber: '', isgetServiceDetails: false,
    };
    this.getmsspAppliances(data);
    localStorage.setItem('registered', 'false');
  }
  registerComplete() {
    this.ifRegistered = localStorage.getItem('registered') || 'false';
    if (this.ifRegistered === 'true') {
      this.registered();
    }
  }
  epss() {

  }

  get firewall() {
    const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    return productObject.serialNumber.concat(' - ', productObject.friendlyName) || '';
  }

  updated() {
    this.productChanged();
  }
  created() {
    this.todaysDate = this.todayDate;
    this.fromScreen = this.from;
    this.oldTenantId = '';
    console.warn(this.showOrgId, 'orgId');
    // const prodObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const anProdObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    // const data = {
    //   tenantId: prodObject.tenantId, productId: anProdObject.productId, serialNumber: '', isgetServiceDetails: anProdObject.productId !== '-1' ? true : false,
    // };
    // console.warn('pro', anProdObject, this.productAnotherModalObject);
    this.prodId = anProdObject.productId.toString() !== '-1' && anProdObject.productId.toString() !== '-6'  && anProdObject.productId.toString() !== '-9' &&
    anProdObject.productId.toString() !== '-7' && anProdObject.productId.toString() !== '-8' && anProdObject.productId.toString() !== '-10' &&
      anProdObject.productId.toString() !== '-14' && anProdObject.productId.toString() !== '-15' && anProdObject.productId.toString() !== '-16'
        && anProdObject.productId.toString() !== '-17' && anProdObject.productId.toString() !== '-18' && anProdObject.productId.toString() !== '-19'
          && anProdObject.productId.toString() !== '-20'
          && anProdObject.productId.toString() !== '-11' && anProdObject.productId.toString() !== '-12' && anProdObject.productId.toString() !== '-13' ? true : false;
    // this.loadAnotherProductApi();
    // if (this.modalType === 'add' && !this.prodChanged) {
    //   // this.showAgree = true;
    //   this.getmsspAppliances(data)
    //   .then(() => {
    //     if (this.prodId) {
    //       this.fwRequest.ProductID = anProdObject.productId;
    //       this.fwRequest.isZT = this.fwProductObject.showZt ? 'YES' : 'NO';
    //       this.populateNsvServices();
    //     }
    //   });
    // } else {
    this.editFriendName = true;
    if (this.modalType !== 'add') {
      // this.showAgree = false;
      const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      const anProdObject = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
      this.fwProductObject.firewall = productObject.serialNumber;
      this.isNsv = anProdObject.productId === '-11' || anProdObject.productId === '-12' || anProdObject.productId === '-14'
       || anProdObject.productId === '-17' || anProdObject.productId === '-18' || anProdObject.productId === '-19'
       || anProdObject.productId === '-15' || anProdObject.productId === '-16' || anProdObject.productId === '-20' ?  true : false;
      // this.firewall = productObject.serialNumber.concat(' - ', productObject.friendlyName);
      this.editFriendName = false;
      this.acceptProvision = true;
      const dataSent = {
        tenantId: productObject.tenantId.toString(), productId: anProdObject.productId.toString(), serialNumber: productObject.serialNumber, isgetServiceDetails: true, mode: 'EDIT',
      };
      this.$store.commit('startLoading');
      this.serviceLabel = '';
      this.childServiceLabel = '';
      this.fwProductObject.serviceName = '';
      this.fwProductObject.childServiceName = '';
      this.showExpiry = false;
      this.showChildExpiry = false;
      this.fwProductObject.ShowUpperLimit = false;
      this.fwProductObject.ShowChildUpperLimit = false;
      this.getmsspAppliances(dataSent)
      .then(() => {
        this.fwRequest.ProductID = anProdObject.productId;
        this.fwRequest.serialNumber = productObject.serialNumber;
        this.showOrgId ? this.populateNsvServices() : this.onFirewallSelected();
        this.$emit('msspApplicancesApiCompleted');
      });
    }
  }

  beforeDestroy() {
    if (this.registerReturnHandler) {
      document.removeEventListener('visibilitychange', this.registerReturnHandler);
      this.registerReturnHandler = null;
    }
  }

  totalCount(nodecount:number, totalcount:string) {
    const parsedTotalCount = (totalcount !== '' && Number(totalcount)) || null;
    if (parsedTotalCount !== null) {
      return +nodecount + +parsedTotalCount;
    }
  }
}
